var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"align":_vm.alignment,"justify":_vm.justify}},[_vm._t("default")],2)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }